export default {
  mediaSaturation: 'Saturación de Medios (%)'
}
